export const ACCOUNT_LINKING_STATUSES = {
  SUCCESS: 'SUCCESS',
}

export const ENDPOINTS = {
  YODLEE_ACCOUNTS: '/v2/shopping_rewards/accounts',
  YODLEE_FASTLINK_PARAMS: '/v2/shopping_rewards/yodlee-fastlink-params',
  SHOPPING_REWARDS_STATISTICS: '/v2/shopping_rewards/statistics/',
}
